export const errorsModels = new Map<string, string>([
  ['invalid_token', 'Invalid token'],
  ['invalid_grant', 'Invalid token'],
  // TODO: Adapt when we need to parse other back-end errors
  ['emailAlreadyExist', 'error-notification.email-already-exist'],
  ['requiredAttributeInRequest', 'error-notification.required-attribute-in-request'],
  ['incorrectAttributeValue', 'error-notification.incorrect-attribute-value'],
  ['invalidAttribute', 'error-notification.invalid-attribute'],
  ['accessTokenNotFound', 'error-notification.access-token-not-found'],
  ['expiredToken', 'error-notification.expired-token'],
  ['invalidUserCredentials', 'error-notification.invalid-user-credentials'],
  ['clientTokenNotValid', 'error-notification.client-token-not-valid'],
  ['userNotFound', 'error-notification.user-not-found'],
  ['emailNotActive', 'error-notification.email-not-active'],
  ['invalidRefreshToken', 'error-notification.token-expiration'],
  ['unmappedError', 'error-notification.unmapped-error'],
  ['zipCodeNotValid', 'error-notification.zipcode-not-valid'],
  ['invalidEmailFormat', 'error-notification.invalid-email-format'],
  ['emailNotValid', 'error-notification.validate-email'],
  ['documentNumberAlreadyExist', 'error-notification.document-number-already-exist']
]);
